import { OverlayTrigger, Popover } from "react-bootstrap";
import { ReactComponent as MenuIcon } from "../../assets/img/grid-menu.svg";
import { ICellRendererParams } from "ag-grid-community";
import { useState, useRef, useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { createClinicalFormsApi } from "../../api-helpers/ClinicalFormsApiHelper";
import { getAllMemberForms, getOneMemberForm } from "./apiUtils.assessment";
import { ClinicalFormsConstants } from "../ClinicalForms/ClinicalFormsConstants";
import { showToast } from "../../store/slices/toastSlice";
import { useDispatch } from "react-redux";

interface Data {
  latestMemberFormId: string;
  assessmentTypeId: string;
  lastStatus: string;
  lastSubmittedAt: string | null;
}

// Extend the ICellRendererParams interface from AG-Grid
interface ViewIconParams extends ICellRendererParams {
  data: Data;
}

export const AssessmentsGridActionIcon = (props: ViewIconParams) => {
  const [show, setShow] = useState(false);
  const iconRef = useRef<HTMLDivElement | null>(null);

  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const assessmentId = searchParams.get("assessmentId");
  const { patientId } = useParams<{ patientId: string }>();

  const assessmentTypeId = props.data.assessmentTypeId

  const clinicalFormsApi = createClinicalFormsApi();

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    setShow(!show);
  };

  const openNewAssessment = async (event: React.MouseEvent) => {
    event.stopPropagation();
    // await assignClinicalForm(assessmentTypeId, patientId!, assessmentId)
    
    navigate(`${assessmentTypeId}/start`)
    
  };

  const resumeAssessment = async () => {
    // const memberForm = await getMemberForm(props.data.latestMemberFormId);
    navigate(`${assessmentTypeId}/resume/${props.data.latestMemberFormId}`);
  };

  const displayHistory = async () => {
    const allMemberFormsResponse = await getAllMemberForms(patientId!)
      const submittedForms = allMemberFormsResponse?.data.
      filter((form) => form.status === ClinicalFormsConstants.submittedStatus &&
          form.formId === assessmentTypeId);

      if (!submittedForms?.length) {
        dispatch(
          showToast({
            type: "warning",
            title: "No past assessment found!",
            message: "",
            icon: "error_outline",
          })
        );
      } else {
        navigate(`${assessmentTypeId}/history`)
      }
  };

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (
        iconRef.current &&
        !iconRef.current.contains(event.target as Node) &&
        !(event.target as HTMLElement).closest(".custom-popover")
      ) {
        setShow(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <OverlayTrigger
      trigger="click"
      placement="left"
      show={show}
      overlay={
        <Popover id="popover-basic" className="custom-popover">
          <div className="popover-content">
            {props.data.lastStatus === "draft" ? (
              <button className="popover-button" onClick={resumeAssessment}>
                Resume
              </button>
            ) : (
              <button className="popover-button" onClick={openNewAssessment}>
                New
              </button>
            )}
            <button className="popover-button" onClick={displayHistory}>
              Past Assessments
            </button>
          </div>
        </Popover>
      }
    >
      <div ref={iconRef} onClick={handleClick} role="button">
        <MenuIcon />
      </div>
    </OverlayTrigger>
  );
};
